module.exports = __webpack_public_path__ + "img/2.689d4599.jpg";